/** Enhance the header contact link while preserving normal link navigation. */
(function () {
  if (window.slkHeaderHelpBound) return;
  window.slkHeaderHelpBound = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-header-chat]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var widget = window.MimirBubbleV2;
    var host = document.getElementById('mimir-bubble-v2-root');
    if (!widget || typeof widget.open !== 'function' || !host || !host.shadowRoot) return;
    event.preventDefault();
    if (link.hasAttribute('aria-busy')) return;
    link.setAttribute('aria-busy', 'true');
    var finished = false;
    var timer;
    var deadline = Date.now() + 8000;
    function finish(fallback) {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      link.removeAttribute('aria-busy');
      if (fallback) window.location.assign(link.href);
    }
    function check() {
      var panel = host.shadowRoot.querySelector('[role="tabpanel"]');
      if (panel && panel.getClientRects().length && getComputedStyle(panel).visibility !== 'hidden') return finish(false);
      if (Date.now() >= deadline) return finish(true);
      timer = setTimeout(check, 100);
    }
    try {
      Promise.resolve(widget.open()).catch(function () { finish(true); });
      check();
    } catch (error) {
      finish(true);
    }
  });
})();
